module.exports = __webpack_public_path__ + "static/media/21ECLAC26.008f1dfa.jpg";